module.exports = __webpack_public_path__ + "static/media/smile.b7b3cad0.svg";